define("powergen/components/x-system-overlay",
  [],
  function() {
    "use strict";
    var XSystemOverlayComponent;

    XSystemOverlayComponent = Ember.Component.extend({
      tagName: 'div',
      classNames: ['overlay', 'system-overlay'],
      classNameBindings: ['show'],
      actions: {
        close: function() {
          this.set('show', false);
          return this.sendAction('close');
        }
      },
      show: false
    });


    return XSystemOverlayComponent;
  });